export default "__VITE_ASSET__7b368cfb__"